"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({prerequisites, fn}) {
        this.state = { prerequisites: Array.isArray(prerequisites) && prerequisites.length ? prerequisites : [{ label: '' }] };
        this.callbackFn = fn;
    },
    onAddMore: function () {
        this.state.prerequisites.push({ label: '' });
        this.setStateDirty('prerequisites');
    },
    onRemove: function (index) {
        this.state.prerequisites.splice(index, 1);
        this.setStateDirty('prerequisites');
    },
    onChange: function (name, index, e) {
        this.state.prerequisites[index][name] = e.target.value;
        this.setStateDirty('prerequisites');
    },
    onDone: function () {
        const toReturn = this.state.prerequisites.filter(({label}) => {
            return !!label;
        });
        typeof this.callbackFn == 'function' && this.callbackFn(toReturn);
        this.emit('done', toReturn);
        this.emit('dismiss');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/PrerequisiteForm.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Bx_template = require("../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("2013b7"),
    marko_node0 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "21", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "pr-group"
      },
    marko_attrs2 = {
        "class": "py-1"
      },
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_attrs5 = {
        "class": "position-absolute right-0 btn btn-icon rounded-circle border theme-bg",
        style: "margin-top:-33px"
      },
    marko_attrs6 = {
        "class": "col-md-6 col-3"
      },
    marko_attrs7 = {
        "class": "btn btn-secondary btn-lg mx-25"
      },
    marko_attrs8 = {
        "class": "col text-right"
      },
    marko_attrs9 = {
        "class": "btn btn-secondary btn-lg mx-25"
      },
    marko_attrs10 = {
        "class": "btn btn-primary btn-lg mx-25"
      };

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "position-absolute zindex-2 w-100 h-100 top-0 left-0 d-flex center",
      renderBody: function(out) {
        Row_tag({
            class: "m-0 w-100 d-flex justify-content-center",
            renderBody: function(out) {
              out.e("div", marko_attrs0, "2", component, 0, 0, {
                  onclick: __component.d("click", () => component.emit('dismiss'), false)
                });

              WSAdapt_tag({
                  ns: "col-md-4 col-10",
                  qs: "col-md-6 col-10",
                  hs: "col-md-8 col-10",
                  class: "animated zoomIn faster",
                  style: "padding-top:150px;padding-bottom:150px",
                  renderBody: function(out) {
                    out.be("h5", null, "4", component);

                    Locale_tag({
                        text: input.for.toCapitalCase() + " Prerequisites"
                      }, out, __component, "5");

                    out.ee();

                    out.n(marko_node0, component);

                    marko_forOf(state.prerequisites, function({ label, link }, index) {
                      var $keyValue$0 = "@" + index,
                          $keyScope$0 = "[" + ($keyValue$0 + "]");

                      out.be("div", marko_attrs1, $keyValue$0, component);

                      if (index > 0) {
                        out.e("hr", null, "7" + $keyScope$0, component, 0);

                        out.be("button", marko_attrs5, "8" + $keyScope$0, component, null, 0, {
                            onclick: __component.d("click", "onRemove", false, [
                                index
                              ])
                          });

                        Bx_tag({
                            type: "x",
                            class: "font-medium-3"
                          }, out, __component, "9" + $keyScope$0);

                        out.ee();
                      }

                      out.be("div", marko_attrs2, "10" + $keyScope$0, component);

                      out.be("div", marko_attrs3, "11" + $keyScope$0, component);

                      out.be("label", null, "12" + $keyScope$0, component);

                      Locale_tag({
                          text: "Label",
                          class: "text-muted"
                        }, out, __component, "13" + $keyScope$0);

                      out.ee();

                      out.e("br", null, "14" + $keyScope$0, component, 0);

                      out.e("input", {
                          type: "text",
                          value: label,
                          required: true,
                          "class": "form-control form-control-xl px-2",
                          placeholder: Locale("Label*")
                        }, "15" + $keyScope$0, component, 0, 0, {
                          oninput: __component.d("input", "onChange", false, [
                              "label",
                              index
                            ])
                        });

                      out.ee();

                      out.be("div", marko_attrs4, "16" + $keyScope$0, component);

                      out.be("label", null, "17" + $keyScope$0, component);

                      Locale_tag({
                          text: "Link",
                          class: "text-muted"
                        }, out, __component, "18" + $keyScope$0);

                      out.ee();

                      out.e("br", null, "19" + $keyScope$0, component, 0);

                      out.e("input", {
                          type: "url",
                          value: link,
                          "class": "form-control form-control-xl px-2",
                          placeholder: Locale("Link (Optional)")
                        }, "20" + $keyScope$0, component, 0, 0, {
                          onchange: __component.d("change", "onChange", false, [
                              "link",
                              index
                            ])
                        });

                      out.ee();

                      out.ee();

                      out.ee();
                    });

                    out.n(marko_node1, component);

                    Row_tag({
                        renderBody: function(out) {
                          out.be("div", marko_attrs6, "23", component);

                          out.be("button", marko_attrs7, "24", component, null, 0, {
                              onclick: __component.d("click", () => component.emit('dismiss'), false)
                            });

                          Locale_tag({
                              text: "Cancel"
                            }, out, __component, "25");

                          out.ee();

                          out.ee();

                          out.be("div", marko_attrs8, "26", component);

                          out.be("button", marko_attrs9, "27", component, null, 0, {
                              onclick: __component.d("click", "onAddMore", false)
                            });

                          Locale_tag({
                              text: "Add"
                            }, out, __component, "28");

                          out.ee();

                          if ( state.prerequisites.filter( ({ label }) => { return !!label } ).length ) {
                            out.be("button", marko_attrs10, "29", component, null, 0, {
                                onclick: __component.d("click", "onDone", false)
                              });

                            Locale_tag({
                                text: "Done"
                              }, out, __component, "30");

                            out.ee();
                          }

                          out.ee();
                        }
                      }, out, __component, "22");
                  }
                }, out, __component, "3");
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
